module.exports = (__webpack_require__(0))(104);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/widgets/FolderListWidget.js from dll-reference girder_lib
// module id = 118
// module chunks = 0